import { render, staticRenderFns } from "./keyPartCertificateDetail.vue?vue&type=template&id=d18e842e&scoped=true&"
import script from "./keyPartCertificateDetail.vue?vue&type=script&lang=js&"
export * from "./keyPartCertificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./keyPartCertificateDetail.vue?vue&type=style&index=0&id=d18e842e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18e842e",
  null
  
)

export default component.exports